import apiRequest from "../utils/ApiRequest/apiRequest";

const ReactGetFavoriteContactListApiRequest = async () => {
  const response = await apiRequest( "ContactsLists",
    "ReactGetFavoriateContactList");

  return response;
};

export { ReactGetFavoriteContactListApiRequest };
